import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';

export default class DashboardSeller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    showBuyerList(){
        axios.get('https://spice-api.pearlfall.vercel.app'+`/users/seller/dashboard`, this.state)
            .then(function (response) {
                console.log('response', response);
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        return (
            <React.Fragment>
                <Container fluid = {true}>
                    <Row>
                        <Col xs="3"></Col>
                        <Col xs="9">

                        </Col>

                    </Row>
                </Container>
            </React.Fragment>

        );
    }
}
